import { useEffect, useState } from 'react';

// These breakpoints are matching with the ones in 'constants.scss'
export enum Breakpoints {
  LG_MAX = 1199,
  MD_MAX = 991,
  SM_MAX = 768,
  XSM_MAX = 449,
}

export const useBreakpoint = (minWidth: number) => {
  const [throttled, setThrottled] = useState(false);
  const [overMinWidth, setOverMinWidth] = useState(
    () => window.innerWidth >= minWidth
  );

  useEffect(() => {
    const handleResize = () => {
      if (!throttled) {
        setOverMinWidth(window.innerWidth >= minWidth);
        setThrottled(true);
        setTimeout(() => {
          setThrottled(false);
        }, 100);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      setThrottled(true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minWidth, setOverMinWidth]);
  return overMinWidth;
};
